import {createSlice, PayloadAction} from '@reduxjs/toolkit';

type PaymentsEventParams = {
  type: string | undefined;
  paymentId?: number | undefined;
};

const initialState: PaymentsEventParams[] = [];

const paymenEventParamsSlice = createSlice({
  name: 'paymenEventParamsSlice',
  initialState,
  reducers: {
    setType(state, action: PayloadAction<PaymentsEventParams>) {
      state.push(action.payload);
    },
  },
});

export const {setType} = paymenEventParamsSlice.actions;

export default paymenEventParamsSlice.reducer;
